export enum PointType {
    UNITY,
    START,
    END,
    UNITYT_START_END,
    UNITY_START,
    UNITY_END,
    START_END
}